export const transactionConstants = {
    RESET_TRANSACTION_DATA: "RESET_TRANSACTION_DATA",

    TRANSACTION_LIST_SAGA: "TRANSACTION_LIST_SAGA",
    TRANSACTION_LIST_REQUEST: "TRANSACTION_LIST_REQUEST",
    TRANSACTION_LIST_RESPONSE: "TRANSACTION_LIST_RESPONSE",
    TRANSACTION_LIST_API: "v1/portfolio/purchase",
};
